import {
    VRCORE_GET_JOB_PACKS,
    VRCORE_REMOVE_JOB_PACK,
    VRCORE_SET_SEARCH,
    SET_DATE_FROM,
    SET_DATE_TO,
    VRCORE_SET_ORDERKEY,
    VRCORE_SET_ORDERBY
} from "./types";

const INITIAL_STATE = {
    requesting: false,
    jobPacks: false,
    removing: false,
    search: "",
    dateFrom: false,
    dateTo: false,
    orderBy: "reverse",
    orderKey: "job_id"
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case VRCORE_GET_JOB_PACKS.REQUEST: {
            return { ...state, requesting: true, jobPacks: false };
        }
        case VRCORE_GET_JOB_PACKS.FAIL: {
            return { ...state, requesting: false, jobPacks: false };
        }
        case VRCORE_GET_JOB_PACKS.SUCCESS: {
            return {
                ...state,
                requesting: false,
                jobPacks: action.payload
            };
        }

        case VRCORE_SET_SEARCH: {
            return {
                ...state,
                search: action.payload
            };
        }
        case VRCORE_SET_ORDERBY: {
            return {
                ...state,
                orderBy: action.payload
            };
        }
        case VRCORE_SET_ORDERKEY: {
            return {
                ...state,
                orderKey: action.payload
            };
        }
        case SET_DATE_FROM: {
            return { ...state, dateFrom: action.payload };
        }
        case SET_DATE_TO: {
            return { ...state, dateTo: action.payload };
        }
        case VRCORE_REMOVE_JOB_PACK.REQUEST: {
            return { ...state, requesting: true, removing: true };
        }
        case VRCORE_REMOVE_JOB_PACK.SUCCESS: {
            return { ...state, requesting: false, removing: false };
        }
        case VRCORE_REMOVE_JOB_PACK.FAIL: {
            return { ...state, requesting: false, removing: false };
        }

        default: {
            return state;
        }
    }
};
